import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TOAST_CONFIG, ToastrModule } from 'ngx-toastr';
import { ComunesService } from './services/comunes.service';
import { WebServiceWorker } from './services/worker/web-service-worker.service';
import { UpdateWorkerComponent } from './shared/components/update-worker/update-worker.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, ToastrModule, RouterOutlet, NgxSpinnerModule, UpdateWorkerComponent],
  providers: [
    {
      provide: TOAST_CONFIG,
      useValue: {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      },
    },
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'seleccion-personas';

  isNewAppVersionAvailable: boolean = false;
  newAppUpdateAvailableSubscription: any;

  private webServiceWorker = inject(WebServiceWorker);
  private comunesService = inject(ComunesService);

  ngOnInit(): void {
    this.checkIfAppUpdated();
    this.comunesService.prefetchStaticData();
  }

  checkIfAppUpdated() {
    this.newAppUpdateAvailableSubscription =
      this.webServiceWorker.$isAnyNewUpdateAvailable.subscribe((versionAvailableFlag: boolean) => {
        this.isNewAppVersionAvailable = versionAvailableFlag;
      });
  }

  refreshApp() {
    this.webServiceWorker.swUpdate.activateUpdate().then(() => document.location.reload());
  }

  ngOnDestroy() {
    if (this.newAppUpdateAvailableSubscription) {
      this.newAppUpdateAvailableSubscription.unsubscribe();
    }
  }
}
